module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Cover__container"
  }, [_c('div', {
    staticClass: "wall__fill"
  }), _vm._v(" "), _c('svg-window', {
    attrs: {
      "flyFSwtich": _vm.flyFSwtich
    },
    on: {
      "zoomIn": _vm.zoomInAnimation,
      "getShock": _vm.getShockAniamtion
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wall__fill"
  }), _vm._v(" "), _c('svg-man', {
    staticClass: "cover__man",
    attrs: {
      "shockSwitch": _vm.shockSwitch
    },
    on: {
      "makeTitleFly": _vm.makeTitleFly
    }
  }), _vm._v(" "), _c('svg-computer', {
    staticClass: "cover__computer"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn__skip"
    },
    on: {
      "~click": function($event) {
        _vm.zoomInAnimation($event)
      }
    }
  }, [_vm._v("SKIP!")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f1157c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/Cover/Cover.vue
// module id = 61
// module chunks = 0